import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import userApi, { CreateUserRequest } from '../../data/api/user/user-api'
import { saveLoggedInUser } from '../../data/auth/auth-storage'

const RegisterPage = (): React.JSX.Element => {
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [errorMessage, setErrorMessage] = useState('')
  const [successMessage, setSuccessMessage] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)
  const navigate = useNavigate()

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    setErrorMessage('')
    setSuccessMessage('')
    setIsSubmitting(true)

    const payload: CreateUserRequest = {
      firstName,
      lastName,
      email,
      password,
    }

    try {
      const user = await userApi.createUser(payload)
      saveLoggedInUser(user)
      setSuccessMessage('Registration successful. Redirecting to profile...')
      setFirstName('')
      setLastName('')
      setEmail('')
      setPassword('')
      navigate('/UserProfile')
    } catch (error) {
      const message = error instanceof Error ? error.message : 'Registration failed. Please try again.'
      setErrorMessage(message)
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <div
      style={{
        background: 'linear-gradient(180deg, #0b1220 0%, #0f1724 100%)',
        minHeight: '100vh',
        width: '100vw',
        marginLeft: 'calc(50% - 50vw)',
        color: 'white',
        padding: '40px'
      }}
    >
      <div style={{ maxWidth: '500px', margin: '0 auto' }}>
        <h1>NextQuest Register</h1>

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="auth-field">
            <label htmlFor="firstName">First Name</label>
            <input
              id="firstName"
              type="text"
              placeholder="Enter first name"
              value={firstName}
              onChange={(event) => setFirstName(event.target.value)}
              required
            />
          </div>

          <div className="auth-field">
            <label htmlFor="lastName">Last Name</label>
            <input
              id="lastName"
              type="text"
              placeholder="Enter last name"
              value={lastName}
              onChange={(event) => setLastName(event.target.value)}
              required
            />
          </div>

          <div className="auth-field">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              placeholder="Enter email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              required
            />
          </div>

          <div className="auth-field">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              placeholder="Enter password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              required
            />
          </div>

          {errorMessage && <p>{errorMessage}</p>}
          {successMessage && <p>{successMessage}</p>}

          <button type="submit" disabled={isSubmitting}>
            {isSubmitting ? 'Registering...' : 'Register'}
          </button>
        </form>
      </div>
    </div>
  )
}

export default RegisterPage
